
import React, { Fragment, useEffect, useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import clsx from "clsx";

//Material-UI Core Components
import Typography from "@mui/material/Typography";
import Collapse from "@mui/material/Collapse";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionActions from "@mui/material/AccordionActions";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";

//Material-UI Icons
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AssessmentIcon from "@mui/icons-material/Assessment";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import EventIcon from "@mui/icons-material/Event";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { Panorama } from "@mui/icons-material";

//Custom Components
import MapCard from "@/ui/MapCard/MapCard";
import MapCardHeader from "@/ui/MapCard/MapCardHeader";
import MapCardAvatar from "@/ui/MapCard/MapCardAvatar";
import MapCardContent from "@/ui/MapCard/MapCardContent";
import MapCardActions from "@/ui/MapCard/MapCardActions";
import MapCardActionButton from "@/ui/MapCard/MapCardActionButton";
import { formats } from "@/lib/formats";
import dataController from "@/lib/dataController";
import MapCardHeaderButtonClose from "@/ui/MapCard/MapCardHeaderButtonClose";
import DialogContext from "@/ui/DialogContext/DialogContext";
import { GridContainer, GridItem } from "@/ui/Grid";
import ModelTable from "@/ui/Table/ModelTable";
// import { dataService } from "@/services/dataService";
import FormContent from "@/components/FormContent";
import UserContext from "@/components/UserContext/UserContext";

// import modelPregled from "@/models/pregledi";
// import ImageSlider from "@/components/ImageSlider";

import modelData from "@/models/data";
import modelObjekti from "@/models/objekti";
import modelDkp from "@/models/dkp";
import modelVlasnici from "@/models/vlasnici";
import modelKablovi from "@/models/kablovi";
import modelPaceracija from "@/models/parcelacija";
import modelSolari from "@/models/solari";
import modelTrafostanice from "@/models/trafostanice";
import modelUporaba from "@/models/uporaba";
import modelZone from "@/models/zone";
import modelPaneli from "@/models/paneli";

// import DataDialog from "@/views/MapPage/DataDialog";
// import InspectionDialog from "@/views/MapPage/InspectionDialog";

//Types
import { DCRecord } from "@/@types/lib/dataController";
import { GFIFeatureType } from "@/services/gsService";
import { CardOverlayType } from "@/@types/views/GIS/map";

export type CardPosition = [number, number]

export interface ICardOverlayData {
  position: CardPosition
  feature: GFIFeatureType
  type: CardOverlayType
  record?: DCRecord
}
export interface GSInfoCardProps {
  featureData: ICardOverlayData,
  onClose: any,
  expanded: boolean,
  setExpanded: React.Dispatch<React.SetStateAction<boolean>>

}

function GSInfoCard(props: GSInfoCardProps) {
  const { t } = useTranslation();

  const initialRecod = props.featureData.record ? props.featureData.record : props.featureData.feature.properties;

  const [record, setRecord] = useState(initialRecod);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [loadStatus, setLoadStatus] = useState({ isLoading: true, isLoaded: false });
  const [imageLoadStatus, setImageLoadStatus] = useState({ imageLoading: true });
  const [recordsVlasnici, setRecordsVlasnici] = useState<DCRecord[]>([]);

  const dialogContext = useContext(DialogContext);
  const userContext = useContext(UserContext);

  const { featureData, onClose, expanded, setExpanded } = props;

  const { type } = featureData;

  const getModel = () => {
    switch (type) {
      case "dkp":
        return modelDkp;
      case "kablovi":
        return modelKablovi
      case "prijedlog_parcelacije":
        return modelPaceracija;
      case "solari":
        return modelSolari;
      case "trafostanice":
        return modelTrafostanice;
      case "uporaba":
        return modelUporaba;
      case "zone":
        return modelZone;
      case "paneli":
        return modelPaneli;
      default:
        return modelData;
    }
  };

  const model = getModel();

  const dc = new dataController(model);
  const dcVlasnici = new dataController(modelVlasnici);

  const faIconClass = "fas fa-info ";

  const recordId = record ? record.id : null;

  const handleRefresh = function () {
    setRefreshCounter(refreshCounter + 1);

    setLoadStatus({ isLoading: true, isLoaded: false });
  };

  const handleDetailCollapse = function () {
    setExpanded(!expanded);
  };

  const loadVlasnici = () => {
    if (record) {
      const id = record.id;
      const ko_mb = record.ko_mb
      let kc_broj_encoded = record.kc_broj

      if (typeof kc_broj_encoded == 'string') {
        kc_broj_encoded = kc_broj_encoded.replace("/", "-") // Couldn't get this to work with uri encoding. Char '/' gets encoded to '%2F' which Django still interprets as '/' and endpoint doesn't work.
      }

      dcVlasnici.GetData(`data/dkp/${id}/zk-vlasnici`)
        .then((resp) => {
          if (resp.success && Array.isArray(resp.data)) {
            setRecordsVlasnici(resp.data);
          }
        })
    }
  };

  const handleGoToPhotoCentric = () => {
    const url =
      location.origin +
      "/paneli/?id=" +
      recordId;
    window.open(url, "_blank"); // opens 3d in a new tab
  }

  useEffect(() => {
    if (recordId) {
      loadVlasnici();
    }
  }, [recordId])


  const handleEdit = () => {
    // const model = getModel(type);
    // const dc = new dataController(model);
    // dialogContext.showDialog(DataDialog, {
    //   type: type,
    //   dc: dc,
    //   recordId: record.id,
    //   mode: "update",
    //   form: "edit",
    //   iconClass: faIconClass,
    //   onClose: (result) => handleDataDialogClose(result, record.id)
    // });
  };

  // const handleDataDialogClose = (dialogResult, recordId) => {
  //   if (dialogResult.dataChanged) {
  //     // dataService.getData(recordId).then((result) => {
  //     //   if (result.success) {
  //     //     setRecord(result.data);
  //     //   }
  //     // });
  //   }
  // };

  // const refreshInspections = () => {
  //   // dataService.getPreglediById(record.id).then((resp) => {
  //   //   if (resp) {
  //   //     setInspections(resp);
  //   //   } else {
  //   //     setInspections(null);
  //   //   }
  //   //   setLoadStatus({
  //   //     isLoading: false,
  //   //     isLoaded: true
  //   //   });
  //   // });
  // };

  // useEffect(() => {
  //   refreshInspections();
  // }, [record.id, refreshCounter]);

  useEffect(() => {
    if (featureData) {
      if (featureData.record) {
        setRecord(featureData.record);
      } else if (featureData.feature) {
        setRecord(featureData.feature.properties);
      }
    }
    setRecord;
  }, [featureData]);

  const form = "default";
  const title = record.naziv ? record.naziv : type ? t("map:layer." + type) : "Info";

  const hasActions = ["dkp", "paneli"].includes(type);
  const allowMore = type === "dkp" ? true : false;

  const hasVlasnici = recordsVlasnici.length > 0;

  return (
    <Fragment>
      <MapCard
        sx={{
          backgroundColor: "background.default",
          minWidth: "500px"
        }}
      >
        <MapCardHeader
          title={title}
          subheader={t("common.id") + ": " + record.id}
          subheaderTypographyProps={{ color: "initial" }}
          avatar={<MapCardAvatar ariaLabel="info" icon={<i className={faIconClass}></i>} />}
          action={<MapCardHeaderButtonClose onClick={onClose} />}
        />
        <MapCardContent>
          <GridContainer spacing={0}>
            <GridItem xs={12} container>
              {/* <Form dc={dc} mode="view" form={form} record={record}> */}
              <GridContainer spacing={0}>
                <FormContent
                  // dc={dc}
                  // form={form}
                  fields={dc.getFormFields(form)}
                  fieldNames={dc.getFormFieldsNames(form)}
                  columns={1}
                  mode="simpleView"
                  record={record}
                />
              </GridContainer>
              {/* </Form> */}
            </GridItem>
            {/* <GridItem xs={6}>Image Placeholder</GridItem> */}
          </GridContainer>
        </MapCardContent>
        {hasActions ? (
          <MapCardActions>

            {allowMore ? (
              <MapCardActionButton
                startIcon={type === "dkp" ? <AssignmentIndIcon /> : <EventIcon />}
                endIcon={
                  <ExpandMoreIcon
                    sx={[
                      {
                        transform: 'rotate(0deg)',
                        transition: (theme) => theme.transitions.create('all', {
                          duration: theme.transitions.duration.shortest,
                        })
                      },
                      expanded && {
                        transform: 'rotate(180deg)'
                      }
                    ]}
                  />
                }
                onClick={handleDetailCollapse}
                aria-expanded={expanded}
                aria-label="expand"
                stickyRight={true}
                disabled={!hasVlasnici}
              >
                {type === "dkp" ? t("buttons.vlasnici") : null}
              </MapCardActionButton>
            ) : null}
            {type === "paneli" ? (
              <MapCardActionButton
                startIcon={<Panorama />}
                onClick={(evt) => handleGoToPhotoCentric()}
              >
                {t('buttons.go_to_photo')}
              </MapCardActionButton>
            ) : null}
          </MapCardActions>
        ) : null}
         {type === "dkp" ? (
          <Collapse in={expanded} timeout="auto" unmountOnExit sx={{ maxHeight: 400, overflowX: 'scroll' }}>
            <ModelTable 
              title=" " 
              tableName="vlasnici"
              viewName="default"
              records={recordsVlasnici || []} 
              dc={dcVlasnici} 
              allowSelection="none" 
              allowAdd={false}
              initialPageSize={25}
              allowRowAction={(() => { return false; })}
              onRowAction={() => {}} 
              />
          </Collapse>
        ) : null}
      </MapCard>
    </Fragment>
  );
}

export default GSInfoCard;
